export function mergeDeepObjects(deleteNullObjects, target, ...sources) {
  function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item)
  }
  if (!sources.length) return target
  const source = sources.shift()
  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (
        (source[key] === null || source[key] === undefined) &&
        deleteNullObjects
      ) {
        // delete null props
        delete source[key]
        if (target[key]) {
          delete target[key]
        }
        continue
      }
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} })
        } else {
          target[key] = Object.assign({}, target[key])
        }
        mergeDeepObjects(deleteNullObjects, target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }
  return mergeDeepObjects(deleteNullObjects, target, ...sources)
}

const toCamelCase = (str) => {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

const hasUnderscoreKey = (obj) => {
  if (Array.isArray(obj)) {
    return obj.some(hasUnderscoreKey)
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).some(
      (key) => key.includes('_') || hasUnderscoreKey(obj[key])
    )
  }
  return false
}

export function convertKeysToCamelCaseIfAny(obj) {
  if (!hasUnderscoreKey(obj)) return obj

  if (Array.isArray(obj)) {
    return obj.map(convertKeysToCamelCaseIfAny)
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        toCamelCase(key),
        convertKeysToCamelCaseIfAny(value)
      ])
    )
  }
  return obj
}

const toSnakeCase = (str) => {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase()
}

const hasCamelCaseKey = (obj) => {
  if (Array.isArray(obj)) {
    return obj.some(hasCamelCaseKey)
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).some(
      (key) => /[A-Z]/.test(key) || hasCamelCaseKey(obj[key])
    )
  }
  return false
}

export function convertKeysToSnakeCaseIfAny(obj) {
  if (!hasCamelCaseKey(obj)) return obj

  if (Array.isArray(obj)) {
    return obj.map(convertKeysToSnakeCaseIfAny)
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        toSnakeCase(key),
        convertKeysToSnakeCaseIfAny(value)
      ])
    )
  }
  return obj
}
